module.exports = __webpack_public_path__ + "static/media/logo-licitama.b16d136e.png";